import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A yard stack of cable drums lying on their sides: three timber reels of
// different sizes chocked so they do not roll, each wound with cable. The
// stockpile a site draws line from.
const FLANGE = "#9c7338";
const FLANGE_DK = "#6f5224";
const CABLE = "#3b3b44";
const CHOCK = "#4a4a4e";

// A drum lying on its side (axis along X), centred at (x,y,z).
function drum(x: number, y: number, z: number, r: number, w: number): Part[] {
  return [
    { geometry: new THREE.CylinderGeometry(r, r, 0.05, 16), color: FLANGE, position: [x - w / 2, y, z], rotation: [0, 0, Math.PI / 2] },
    { geometry: new THREE.CylinderGeometry(r, r, 0.05, 16), color: FLANGE, position: [x + w / 2, y, z], rotation: [0, 0, Math.PI / 2] },
    { geometry: new THREE.CylinderGeometry(r * 0.8, r * 0.8, w - 0.05, 16), color: CABLE, position: [x, y, z], rotation: [0, 0, Math.PI / 2] },
    { geometry: new THREE.CylinderGeometry(r * 0.4, r * 0.4, w, 12), color: "#3a3a3e", position: [x, y, z], rotation: [0, 0, Math.PI / 2] },
    // Winding groove bands across the wound cable.
    { geometry: new THREE.TorusGeometry(r * 0.8, 0.014, 4, 16), color: "#2a2a30", position: [x - w * 0.22, y, z], rotation: [0, Math.PI / 2, 0] },
    { geometry: new THREE.TorusGeometry(r * 0.8, 0.014, 4, 16), color: "#2a2a30", position: [x + w * 0.22, y, z], rotation: [0, Math.PI / 2, 0] },
    { geometry: new THREE.TorusGeometry(r * 0.85, 0.012, 4, 16), color: FLANGE_DK, position: [x - w / 2 - 0.02, y, z], rotation: [0, Math.PI / 2, 0] },
  ];
}

export const cableDrumStack = defineModel({
  id: "cable-drum-stack",
  batchId: "electric",
  name: "Cable drum stack",
  tags: ["prop", "electric", "power", "cable", "yard"],
  summary: "Cable reels lying chocked in a yard.",
  footprint: 0.6,
  parts(): Part[] {
    return [
      // Chocks so the drums do not roll.
      { geometry: new THREE.BoxGeometry(1.0, 0.05, 0.1), color: CHOCK, position: [0, 0.025, -0.36] },
      { geometry: new THREE.BoxGeometry(1.0, 0.05, 0.1), color: CHOCK, position: [0, 0.025, 0.0] },
      ...drum(-0.3, 0.3, -0.1, 0.3, 0.34),
      ...drum(0.32, 0.26, -0.12, 0.26, 0.3),
      ...drum(0.05, 0.22, 0.42, 0.22, 0.26),
    ];
  },
  animations: [],
});
